const generateForm05 = [
  {
    label: "จำนวนเงินเดือน",
    name: "salary_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "มีความประสงค์",
    name: "wish",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ณ",
    name: "place",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_type",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ระยะเวลาที่จะขอไปปฏิบัติงาน",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "จำนวนปี",
    name: "year_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
  {
    label: "จำนวนเดือน",
    name: "month_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
  {
    label: "จำนวนวัน",
    name: "day_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
  {
    label: "เหตุผลของการไปในครั้งนี้",
    name: "reason",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
  {
    label: "ความรู้ภาษาต่างประเทศ",
    name: "knowledge_foreign_languages",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
  {
    label: "สถาบันที่เรียนเคยภาษาต่างประเทศ",
    name: "institution_studied_foreign_languages",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 10 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
  {
    label: "จำนวนปีที่ศึกษา",
    name: "year_amount_studied",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 2 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
  {
    label: "ข้าพเจ้าจะไป",
    name: "will_go",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
  {
    label: "ประโยชน์ต่อตัวเองและมหาวิทยาลัยในการไปครั้งนี้",
    name: "benefits_trip",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "peroid_to_work",
  },
];

export default generateForm05;
